import * as React from 'react'
import useEventStore from 'Store/eventStore'
import { Container } from '@mui/material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import ImageList from 'Components/ImageList'
import Skeleton from '@mui/material/Skeleton';

interface Props {
  onItemSelect: (id: number) => void
  handleDoubleClick?: (id: number) => void
  selected?: number
}
const EventList: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation()
  const { events, loading } = useEventStore()

  if (!events) return null
  const itemData = events.map((e) => {
    return {
      id: e.id,
      src: e.media[0]?.urls.full,
      srcSet: e.media[0]?.srcset,
      title: e.title,
      author: e.user_id,
      isSelected: props.selected === e.id,
      //   featured: true,
    }
  })

  return (
    <>
      {
        React.useMemo(() => <Container>
            <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
            <Typography variant="body2">{t('nav_my_events')}</Typography>
            <Typography variant="body2">{events.length}</Typography>
            </Stack>
        </Container>
        , [events.length])
      }
      {/* {loading
        ? <Container style={{ padding: '10px' }}>
            <Stack spacing={1}>
              {Array.from({ length: 6 }).map((item, index) => 
                <Stack key={index} style={{width: '100%'}} direction="row" spacing={1}>
                {Array.from({ length: 3 }).map((item2, index2) =>
                  <Skeleton key={index2} variant="rectangular" width={'100%'} height={100} style={{borderRadius: '14px'}} />
                )}
                </Stack>
              )}
              </Stack>
          </Container>
        :  */}
        <ImageList
          loading={loading}
          items={itemData}
          onItemSelect={props.onItemSelect}
          handleDoubleClick={props.handleDoubleClick}
        />
        {/* } */}
    </>
  )
}

export default EventList
